import { render, staticRenderFns } from "./SyVoteItem.vue?vue&type=template&id=43f0f951&scoped=true"
import script from "./SyVoteItem.vue?vue&type=script&lang=ts"
export * from "./SyVoteItem.vue?vue&type=script&lang=ts"
import style0 from "./SyVoteItem.vue?vue&type=style&index=0&id=43f0f951&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0f951",
  null
  
)

export default component.exports